// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wl-input-price[data-v-0c0c6e96] {\n  overflow: hidden;\n}\n.wl-input-price .price-string[data-v-0c0c6e96] {\n  width: 100%;\n}\n.wl-input-price .price-string span[data-v-0c0c6e96] {\n  font-size: calc(1em + 1px);\n}\n", ""]);
// Exports
module.exports = exports;
